// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders correctly 1`] = `
Array [
  <ul
    className="m-0 none border-b-1 tg-tab-nav list-none hidden lg:flex"
  >
    <li>
      <a
        className="text-black"
        href="/blog"
      >
        Home
      </a>
    </li>
    <li>
      <a
        className="text-black"
        href="/blog/category/early-learning"
      >
        Early Learning
      </a>
    </li>
    <li>
      <a
        className="text-black"
        href="/blog/category/parenting"
      >
        Parenting
      </a>
    </li>
    <li>
      <a
        className="text-black"
        href="/blog/category/nature"
      >
        Nature
      </a>
    </li>
    <li>
      <a
        className="text-black"
        href="/blog/category/independent-play"
      >
        Independent Play
      </a>
    </li>
    <li>
      <a
        className="text-black"
        href="/blog/category/all"
      >
        All Posts
      </a>
    </li>
  </ul>,
  <div
    className="flex flex-col lg:hidden"
  >
    <div
      className=" css-b62m3t-container"
      onKeyDown={[Function]}
    >
      <span
        className="css-1f43avz-a11yText-A11yText"
        id="react-select-2-live-region"
      />
      <span
        aria-atomic="false"
        aria-live="polite"
        aria-relevant="additions text"
        className="css-1f43avz-a11yText-A11yText"
      />
      <div
        className=" css-1s2u09g-control"
        onMouseDown={[Function]}
        onTouchEnd={[Function]}
      >
        <div
          className=" css-319lph-ValueContainer"
        >
          <div
            className=" css-14el2xx-placeholder"
            id="react-select-2-placeholder"
          >
            Select Blog Category
          </div>
          <div
            className=" css-6j8wv5-Input"
            data-value=""
          >
            <input
              aria-autocomplete="list"
              aria-describedby="react-select-2-placeholder"
              aria-expanded={false}
              aria-haspopup={true}
              autoCapitalize="none"
              autoComplete="off"
              autoCorrect="off"
              className=""
              disabled={false}
              id="react-select-2-input"
              onBlur={[Function]}
              onChange={[Function]}
              onFocus={[Function]}
              role="combobox"
              spellCheck="false"
              style={
                Object {
                  "background": 0,
                  "border": 0,
                  "color": "inherit",
                  "font": "inherit",
                  "gridArea": "1 / 2",
                  "label": "input",
                  "margin": 0,
                  "minWidth": "2px",
                  "opacity": 1,
                  "outline": 0,
                  "padding": 0,
                  "width": "100%",
                }
              }
              tabIndex={0}
              type="text"
              value=""
            />
          </div>
        </div>
        <div
          className=" css-1hb7zxy-IndicatorsContainer"
        >
          <span
            className=" css-1okebmr-indicatorSeparator"
          />
          <div
            aria-hidden="true"
            className=" css-tlfecz-indicatorContainer"
            onMouseDown={[Function]}
            onTouchEnd={[Function]}
          >
            <svg
              aria-hidden="true"
              className="css-tj5bde-Svg"
              focusable="false"
              height={20}
              viewBox="0 0 20 20"
              width={20}
            >
              <path
                d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>,
]
`;



//////////////////
// WEBPACK FOOTER
// ./app/javascript/bundles/ui/CategoryMenu/__snapshots__/index.test.jsx.snap
// module id = 2639
// module chunks = 6